import type { Translated } from '@uefadigital/panenka';
import { PkIcon, PkAvatar, PkBadge } from '@uefadigital/panenka-react';
import { memo } from 'react';

import type { PlayerWithTeam } from '../player-search/types';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';

import * as classes from './styles.module.scss';

const Avatar = ({
  onClick,
  player,
}: {
  onClick: () => unknown;
  player: Translated<PlayerWithTeam>;
  competition: string;
}) => {
  const t = useTranslateFn();
  const { isMobile } = useWindowSize();

  return (
    <div className={classes.avatarContainer}>
      <button type='button' className={classes.avatar} onClick={onClick}>
        {player ? (
          <PkAvatar fallback-image='generic-head' type='image' size={isMobile ? 100 : 210} src={player.imageUrl}>
            {player.team && (
              <PkBadge
                alt={player.team.internationalName}
                slot='badge'
                badge-title={player.team.internationalName}
                fallbackImage='club-generic-badge'
                size={isMobile ? 30 : 48}
                src={player.team.logoUrl}
              />
            )}
          </PkAvatar>
        ) : (
          <PkAvatar fallback-image='generic-head' type='image' size={isMobile ? 100 : 210}>
            <PkBadge alt='Club' slot='badge' fallbackImage='club-generic-badge' size={isMobile ? 30 : 48} />
          </PkAvatar>
        )}
        <PkIcon
          className={classes.plusButton}
          size={24}
          color='interaction-compl'
          name={player ? 'actions-edit' : 'actions-add'}
        />
      </button>
      <span className={classes.playerName}>{player ? player.shortName : t('history_h2h_select_player')}</span>
      <span className={classes.playerPosition}>{player && player.fieldPosition.toLowerCase()}</span>
    </div>
  );
};

export default memo(Avatar);
